import { createSlice } from '@reduxjs/toolkit';
import { getYoutubeById, getYoutube } from 'src/services/youtubeService';

export const youtubeSlice = createSlice({
  name: 'youtubes',
  initialState: {
    loading: false,
    youtubes: [],
    tagsYoutube: [],
    youtubeDetail: {},
    errorMessage: '',
    currentPage: 1,
    totalPage: 1
  },
  reducers: {
    clearState: (state) => {
      state.youtubes = [];
      state.tagsYoutube = [];
      state.youtubeDetail = {};
      state.errorMessage = '';
      state.currentPage = 1;
      state.totalPage = 1;
      state.loading = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getYoutubeById.pending, (state) => {
      state.loading = true;
    }),
      builder.addCase(getYoutubeById.fulfilled, (state, { payload }) => {
        state.youtubeDetail = payload;
        state.loading = false;
        return state;
      }),
      builder.addCase(getYoutubeById.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error;
        state.loading = false;
      }),
      builder.addCase(getYoutube.pending, (state) => {
        state.loading = true;
      }),
      builder.addCase(getYoutube.fulfilled, (state, { payload }) => {
        state.youtubes = payload.data;
        state.currentPage = payload.current_page;
        state.totalPage = payload.last_page;
        state.loading = false;
        return state;
      }),
      builder.addCase(getYoutube.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error;
        state.loading = false;
      });
  }
});

export const youtubeSelector = (state) => state.youtubes;
export const reducer = youtubeSlice.reducer;
export const { clearState } = youtubeSlice.actions;
